/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ClassroomWorksheetsInfiniteScroll_classroom = {
    readonly id: string;
    readonly classroomWorksheets: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"ClassroomWorksheet_classroomWorksheet">;
            } | null;
        } | null> | null;
    };
    readonly " $refType": "ClassroomWorksheetsInfiniteScroll_classroom";
};
export type ClassroomWorksheetsInfiniteScroll_classroom$data = ClassroomWorksheetsInfiniteScroll_classroom;
export type ClassroomWorksheetsInfiniteScroll_classroom$key = {
    readonly " $data"?: ClassroomWorksheetsInfiniteScroll_classroom$data;
    readonly " $fragmentRefs": FragmentRefs<"ClassroomWorksheetsInfiniteScroll_classroom">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ClassroomWorksheetsInfiniteScroll_classroom",
  "type": "Classroom",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "classroomWorksheets"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 50
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "classroomWorksheets",
      "name": "__ClassroomWorksheetsInfiniteScroll_classroomWorksheets_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ClassroomWorksheetConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ClassroomWorksheetEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ClassroomWorksheet",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "ClassroomWorksheet_classroomWorksheet",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '8b83d90efe1868ee30d5e71b74740276';
export default node;
